import * as Type from './actionsTypes';

const startParseRfg = (nsirId, file, force = false, ocr = false, aceitarSemFotos = false) => ({
  type: Type.PARSE_RFG_START,
  nsirId,
  file,
  force: Boolean(force),
  ocr: Boolean(ocr),
  aceitarSemFotos: Boolean(aceitarSemFotos),
});

const fetchParseRfgJob = (nsirId, jobId, { skipExisting } = {}) => ({
  type: Type.PARSE_RFG_FETCH,
  nsirId,
  jobId,
  skipExisting: Boolean(skipExisting),
});

const fetchParseRfgDocumento = (jobId) => ({
  type: Type.PARSE_RFG_FETCH_DOCUMENTO,
  jobId,
});

const clearParseRfgConflict = () => ({ type: Type.PARSE_RFG_CLEAR_CONFLICT });

const clearParseRfgSemFotos = () => ({ type: Type.PARSE_RFG_CLEAR_SEM_FOTOS });

const cleanParseRfg = () => ({ type: Type.PARSE_RFG_CLEAN });

export {
  startParseRfg,
  fetchParseRfgJob,
  fetchParseRfgDocumento,
  clearParseRfgConflict,
  clearParseRfgSemFotos,
  cleanParseRfg,
};
